<h2 mat-dialog-title class="px-3 pt-2">
  <span translate class="me-1">Upload </span>{{ data.uploadType === "details" ? ('Details' | translatepipe) : ("Image" | translatepipe )}}
</h2>
<ng-container *ngIf="errorflag">
  <p>{{errormessage}}</p>
</ng-container>
<input #csvInput hidden type="file" (change)="onFileSelected($event)" />

<div mat-dialog-content class="dialog-content">
  <div class="upload-container">
    <img src="../../../assets/images/bulkupload_logo.svg" (click)="csvInput.click()" alt="Upload Icon"
      class="upload-icon" />
  </div>
  <p *ngIf="selectedFile" class="file-name">{{ selectedFile.name }}</p>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button translate mat-raised-button color="primary" (click)="closeDialog()" mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" (click)="data.uploadType === 'details' ? handleUpload() : handleImagesUpload()" [disabled]="isLoading || !selectedFile">
     <span translate class="me-1">Upload </span>{{ data.uploadType === "details" ? ('Details' | translatepipe) : ("Image" | translatepipe ) }}
  </button>
</div>